const TacticsBanner = ({ bannerData }) => {
  const ctaButtonLink = bannerData.bannerButtonLink;
  const ctaButtonText = bannerData.bannerButton ? bannerData.bannerButton.url : 'Get Started';
  return (
    <div className="cta cta-tactics_banner">
      <div className="cta-banner description_class">
        <div className="cta-banner__container ">
          <h6>{bannerData.bannerTitle}</h6>
          <p>{bannerData.bannerDescription}</p>
          {ctaButtonLink ? (
            <a href={`/${ctaButtonLink}`} className="button">
              {ctaButtonText}
            </a>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default TacticsBanner;
